import React, { useEffect, useState } from "react";
//import { Link } from "react-router-dom";
import axios from "axios";
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { MdRunningWithErrors } from "react-icons/md";
const WithdrawalRequest = () => {
  const [withdrawalRequest, setWithdrawalRequest] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [showModal, setShowModal] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [showModalRetry, setShowModalRetry] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [sentInt, setSentInt] = useState(0);
  const [sortBy, setSortBy] = useState("created_at");
  const [sortDir, setSortDir] = useState("desc");
  const [searchField, setSearchField] = useState("msisdn");
  const [searchValue, setSearchValue] = useState("");

  const handleApprovedClick = (id, approved) => {
    setSelectedRow({ id, approved });
    setShowModal(true);
  };
  //   useEffect(() => {
  //     (async () => {
  //       const { data } = await axios.get(`withdrawalRequest?page=${page}`);
  //       setWithdrawalRequest(data.data);
  //       setLastPage(data.meta.last_page);
  //     })();
  //   }, [page]);
  // const del = async (id) =>{
  //     if(window.confirm("Are you sure you want to delete this record?")){
  //         await axios.delete(`withdrawalRequest/${id}`);
  //         setWithdrawalRequest(withdrawalRequest.filter((withdrawalRequest) => withdrawalRequest.id !== id));
  //     }
  // }

  useEffect(() => {
    fetchWithdrawalRequests();
  }, [page, sortBy, sortDir]);

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortDir(sortDir === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortDir("desc"); // default
    }

    setPage(1); // reset pagination when sorting
  };

  const fetchWithdrawalRequests = async (pageParam = page) => {
    const { data } = await axios.get(
      `withdrawalRequest?page=${pageParam}&sort=${sortBy}&order=${sortDir}&search_field=${searchField}&search_value=${searchValue}`,
    );

    setWithdrawalRequest(data.data);
    setLastPage(data.meta.last_page);
  };

  const renderSortIcon = (column) => {
    if (sortBy !== column) return null;

    return sortDir === "asc" ? " ▲" : " ▼";
  };

  const handleApprove = async () => {
    if (!selectedRow) return;

    try {
      const response = await axios.put(`withdrawalRequest/${selectedRow.id}`, {
        approved: 1,
      });

      if (response.status === 200 || response.status === 204) {
        alert("Status updated successfully.");
        closeModal();
      } else {
        alert("Failed to update status.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      alert("An error occurred.");
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setShowModalRetry(false);
    setSelectedRow(null);
  };

  const handleOpenModal = (id, sentInt) => {
    setSentInt(sentInt);
    setSelectedId(id);
    setShowModalRetry(true);
  };

  const handleSearch = () => {
    setPage(1); // reset pagination

    fetchWithdrawalRequests(1);
  };

  const handleClear = () => {
    setPage(1); // reset pagination
    setSearchField("msisdn");
    setSearchValue("");
    fetchWithdrawalRequests(1);
  };

  const confirmRetry = async () => {
    //onRetry(selectedId);
    console.log("Retrying transaction with ID:", selectedId);
    try {
      const response = await axios.put(
        `withdrawalRetry/${selectedId}`,
        // `withdrawalRetry/${selectedId}/${sentInt}`,
        {
          transaction: 1,
        },
      );
      const isSuccess = response.data.status_code === "0";

      // 🔥 Update the table row
      setWithdrawalRequest((prev) =>
        prev.map((row) => {
          if (row.id === selectedId) {
            return {
              ...row,
              api_response: response.data.message,
              ResultCode: isSuccess ? 0 : 1, // controls retry button visibility
              approved: isSuccess ? 1 : row.approved, // optional depending on your logic
            };
          }
          return row;
        }),
      );

      if (response.status === 200 || response.status === 204) {
        // alert("Status updated successfully.");
        closeModal();
      } else {
        alert("Failed to update status.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      alert("An error occurred.");
    }

    setShowModalRetry(false);
  };
  return (
    <Wrapper pageTitle={"Withdrawal Requests"}>
      {/* <InnerNav
        createLink={"/withdrawalRequestCreate"}
        listLink={"/withdrawalRequest"}
        notes={"Monitor, approve and retry withdrawal transactions"}
      /> */}
      <div className="w-full overflow-hidden rounded-lg shadow-xs">
        <div className="w-full overflow-x-auto">
          <div className="mb-4 flex gap-2">
            {/* Select field */}
            <select
              value={searchField}
              onChange={(e) => setSearchField(e.target.value)}
              className="px-3 py-2 border rounded"
            >
              <option value="msisdn">MSISDN</option>
              <option value="transaction_id">Transaction ID</option>
            </select>

            {/* Input */}
            <input
              type="text"
              placeholder={`Search by ${searchField.replace("_", " ").toUpperCase()}...`}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className="px-3 py-2 border rounded w-full"
            />

            {/* Button */}
            <button
              onClick={() => handleSearch()}
              className="px-4 py-2 bg-gray-700 text-white rounded"
            >
              Search
            </button>

            <button
              onClick={() => handleClear()}
              className="px-4 py-2 bg-gray-700 text-white rounded"
            >
              Clear
            </button>
          </div>
          <Paginator page={page} lastPage={lastPage} pageChanged={setPage} />
          <table className="w-full whitespace-no-wrap">
            <thead className="sticky top-0 bg-gray-50 dark:bg-gray-800">
              <tr className="text-xs/6 font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                <th
                  className="px-4 py-3 cursor-pointer select-none"
                  onClick={() => handleSort("id")}
                >
                  #Ref {renderSortIcon("id")}
                </th>
                <th
                  className="px-4 py-3 cursor-pointer select-none"
                  onClick={() => handleSort("time_in")}
                >
                  Time {renderSortIcon("time_in")}
                </th>
                <th
                  className="px-4 py-3 cursor-pointer select-none"
                  onClick={() => handleSort("msisdn")}
                >
                  Msisdn {renderSortIcon("msisdn")}
                </th>
                <th
                  className="px-4 py-3 cursor-pointer select-none"
                  onClick={() => handleSort("amount")}
                >
                  Amount {renderSortIcon("amount")}
                </th>
                <th
                  className="px-4 py-3 cursor-pointer select-none"
                  onClick={() => handleSort("charges")}
                >
                  Charges {renderSortIcon("charges")}
                </th>
                <th
                  className="px-4 py-3 cursor-pointer select-none"
                  onClick={() => handleSort("net_payout")}
                >
                  Net Payout {renderSortIcon("net_payout")}
                </th>
                <th
                  className="px-4 py-3 cursor-pointer select-none"
                  onClick={() => handleSort("source_ip")}
                >
                  Source Ip {renderSortIcon("source_ip")}
                </th>
                <th
                  className="px-4 py-3 cursor-pointer select-none"
                  onClick={() => handleSort("transaction_id")}
                >
                  Transaction Id {renderSortIcon("transaction_id")}
                </th>
                <th
                  className="px-4 py-3 cursor-pointer select-none"
                  onClick={() => handleSort("approved")}
                >
                  Approved {renderSortIcon("approved")}
                </th>
                <th
                  className="px-4 py-3 cursor-pointer select-none"
                  onClick={() => handleSort("sent_to")}
                >
                  Sent To {renderSortIcon("sent_to")}
                </th>
                <th
                  className="px-4 py-3 cursor-pointer select-none"
                  onClick={() => handleSort("api_response")}
                >
                  API Response {renderSortIcon("api_response")}
                </th>
                <th className="px-4 py-3">Action</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
              {withdrawalRequest.map((withdrawalRequest) => {
                return (
                  <tr
                    key={withdrawalRequest.id}
                    className={`text-gray-700 dark:text-gray-400 ${
                      withdrawalRequest.approved === 1 &&
                      withdrawalRequest.TransactionID !== ""
                        ? "bg-green-100 dark:bg-green-900"
                        : withdrawalRequest.approved === 1
                          ? "bg-blue-100 dark:bg-blue-900"
                          : withdrawalRequest.ResultCode === 1 &&
                              withdrawalRequest.approved === 1
                            ? "bg-red-100 dark:bg-red-900"
                            : ""
                    }`}
                  >
                    <td className="px-4 py-5">{withdrawalRequest.id}</td>
                    <td className="px-4 py-3 text-sm">
                      {withdrawalRequest.time_in}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {withdrawalRequest.Msisdn}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {withdrawalRequest.Amount}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {withdrawalRequest.charges}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {withdrawalRequest.net_payout}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {withdrawalRequest.SourceIp}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {withdrawalRequest.TransactionID}
                    </td>
                    <td
                      className="px-4 py-3 text-sm"
                      onClick={() =>
                        handleApprovedClick(
                          withdrawalRequest.id,
                          withdrawalRequest.approved,
                        )
                      }
                    >
                      {withdrawalRequest.approved}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {withdrawalRequest.ReceiverPartyPublicName}
                    </td>
                    {/* <td
                      className={`px-4 py-3 text-sm ${
                        withdrawalRequest.ResultCode === 1
                          ? "bg-red-100 dark:bg-red-900"
                          : ""
                      }`}
                    >
                      {withdrawalRequest.api_response}{" "}
                      {withdrawalRequest.ResultDesc}
                    </td> */}
                    <td
                      className={`px-4 py-3 text-sm ${
                        withdrawalRequest.ResultCode === 1
                          ? "bg-red-100 dark:bg-red-900"
                          : withdrawalRequest.ResultCode === 0
                            ? "bg-green-100 dark:bg-green-900"
                            : ""
                      }`}
                    >
                      {withdrawalRequest.api_response}{" "}
                      {withdrawalRequest.ResultDesc}
                    </td>
                    <td>
                      {withdrawalRequest.ResultCode === 1 ||
                      withdrawalRequest.sent === 3 ? (
                        <button
                          onClick={() =>
                            handleOpenModal(
                              withdrawalRequest.id,
                              withdrawalRequest.sent,
                            )
                          }
                          className="flex items-center gap-1 text-red-600 hover:text-red-800"
                        >
                          <MdRunningWithErrors />
                          Retry
                        </button>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {showModal && selectedRow && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md">
                <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-4">
                  Approval Details
                </h2>
                <p className="text-gray-800 dark:text-gray-200 mb-2">
                  ID: <strong>{selectedRow.id}</strong>
                </p>
                <p className="text-gray-800 dark:text-gray-200 mb-4">
                  Approved: <strong>{selectedRow.approved}</strong>
                </p>

                {selectedRow.approved === 0 && (
                  <p className="mb-4">
                    <button
                      onClick={handleApprove}
                      className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                    >
                      Approve
                    </button>
                  </p>
                )}

                <div className="text-right">
                  <button
                    onClick={closeModal}
                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Modal */}
          {showModalRetry && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm">
                <h2 className="text-lg font-semibold mb-4">Confirm Retry</h2>
                <p className="mb-6">
                  Do you really want to retry the transaction?
                </p>
                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => setShowModalRetry(false)}
                    className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={confirmRetry}
                    className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                  >
                    Yes, Retry
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        <Paginator page={page} lastPage={lastPage} pageChanged={setPage} />
      </div>
    </Wrapper>
  );
};
export default WithdrawalRequest;
